import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormArray, FormBuilder, Validators } from '@angular/forms';
import { AreaOfImpactDto, UomDto, PartyDto, TerrainDto } from '@cradua/data';
import Swal from 'sweetalert2';
import { Observable } from 'rxjs';
import { IncidentDto } from '@cradua/data';

@Component({
  selector: 'cradua-areaofimpact',
  templateUrl: './areaofimpact.component.html',
  styleUrls: ['./areaofimpact.component.scss']
})
export class AreaOfImpactComponent implements OnInit {
  @Input() incident:IncidentDto[];
  @Input() selectedIncidentId: IncidentDto;
  @Input() areaofimpacts: AreaOfImpactDto[];
  @Input() uoms: UomDto[];
  @Input() partys: PartyDto[];
  @Input() terrains: TerrainDto[];
  @Output() deleteAreaofImpactEvent = new EventEmitter<any>()
  @Output() emitareaofimpact = new EventEmitter<AreaOfImpactDto[]>()

  areaofimpactForm:FormGroup;
  areaofimpactedFormArray:FormGroup;
  filteredDelete: Array<any> =[];
  selectedAreaofImpact: any;
  selectedIndex = null;
  selectedId: any;
  listView = true;
  gridView = false;

  constructor(private fb: FormBuilder) { }

  ngOnInit() {
    this.createAreaOfImpactForm();

    // this.areaofimpactForm = this.fb.group({AreaOfImpacts: this.fb.array([])});
    if(this.selectedIncidentId != null && this.selectedIncidentId.areaofimpacts?.length){
      this.setAreaOfImpact(this.selectedIncidentId.areaofimpacts);
    }
  }

  createAreaOfImpactForm(){
    this.areaofimpactForm = this.fb.group({
      PartyId: [''],
      TerrainId:[''],
      Remarks:[''],
      UomId:[''],
      Area:[''],
      id: null,
      // IncidentNotificationId: [this.selectedIncidentId.IncidentNotificationId],
      });
      this.areaofimpactedFormArray = this.fb.group({ AreaOfImpacts: this.fb.array([])
        });

  }




   get areaofimpactFormArray(){
    return this.areaofimpactedFormArray.get('AreaOfImpacts') as FormArray;
   }
  setAreaOfImpact(areaofimpacts: AreaOfImpactDto[]) {
    areaofimpacts.forEach(areaimpacted => {
      this.areaofimpactFormArray.push(this.fb.group({
        Remarks: areaimpacted.Remarks,
        UomId:areaimpacted.UomId,
        PartyId:areaimpacted.PartyId,
        TerrainId: areaimpacted.TerrainId,
        Area: areaimpacted.Area,
        id: areaimpacted.id,
        IncidentNotificationId: areaimpacted.IncidentNotificationId,
      }))
    })

  }


  // method to add AreaOfImpact
  addareaofimpact(value: AreaOfImpactDto) {
    const control  = this.areaofimpactedFormArray.controls.AreaOfImpacts as FormArray;
    control.insert(0,
          this.fb.group({
            Remarks: value.Remarks,
            UomId: value.UomId,
            PartyId: value.PartyId,
            TerrainId: value.TerrainId,
            Area: value.Area,

          })
       );
  }

  selectAreaOfImpact(value) {}

   // method to delete areaofimpact from arrary list
  deleteAreaOfImpact(index, value) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this imaginary file!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it'
    }).then((result) => {
      if (result.value) {

  this.areaofimpactFormArray.removeAt(index);
  for ( let i = 0; i < this.areaofimpacts.length; i++) {
      if (i === index) {
        if (value.id !== null) {
          this.filteredDelete.push(this.areaofimpacts[i].id);
         }

      }
    }
  Swal.fire(
          'Deleted!',
          'Your imaginary file has been deleted.',
          'success'
        );
      } else if (result.dismiss === Swal.DismissReason.cancel) {
          Swal.fire(
            'Cancelled',
            'Your imaginary file is safe :)',
            'error'
          );
        }
      });
  }


  addAreaOfImpact(value: AreaOfImpactDto) {

    if(this.areaofimpactForm.invalid) {
      return Swal.fire(
         'Warning!',
         'Please, you cannot add blank field',
         'warning'
       );
       }
       if(this.selectedIndex != null) {

         this.areaofimpactedFormArray.get('AreaOfImpacts')['controls'][this.selectedIndex].patchValue({...value});
       } else {
         this.addareaofimpact(value);
       }
       this.selectedIndex = null;
     this.areaofimpactForm.reset()
  }





  onEdit(index, value: AreaOfImpactDto) {
    console.log(index, value)
    this.selectedIndex = index;
    this.areaofimpactForm.patchValue({Remarks: value.Remarks, Area:value.Area, PartyId:value.PartyId, TerrainId:value.TerrainId, UomId:value.UomId});
  }

  onClearForm() {
    this.selectedIndex = null;
    this.areaofimpactForm.reset();
  }

  onSubmit() {
    // console.log("form bvalue:", formValue);
    // formValue: AreaOfImpactDto[]
    // IncidentNotificationId = this.selectedIncidentId.IncidentNotificationId;
    // this.emitareaofimpact.emit(formValue);
    // if(this.filteredDelete.length !== 0) {
    //   this.deleteAreaofImpactEvent.emit(this.filteredDelete);
    // }

    console.log("details",this.areaofimpactForm.value);
    this.emitareaofimpact.emit(this.areaofimpactedFormArray.value.AreaOfImpacts);
  }

  protected findById = <T>(id: string) =>
  (fieldName: T) => fieldName["id"] === id;

  getPartyName(id: string) {
    return id
      ? this.partys.find(this.findById<PartyDto>(id))
        .PartyName
      : null;
  }

  getUOMName(id:string){
    return id ? this.uoms.find(this.findById<UomDto>(id))
    .UomName:null;
  }

  getTerrainName(id:string){
    return id?this.terrains.find(this.findById<TerrainDto>(id))
    .TerrainName:null;
  }

  // getIncidentNotificationId(id:string){
  // return id?this.incident.find(this.findById<IncidentDto>(id))
  // .IncidentNotificationId:null;
  // }


  onList() {
    this.listView = true;
    this.gridView = false;
  }

  onGrid() {
    this.gridView = true;
    this.listView = false;
  }
}
